import { ApiErrorException } from "./Errors";
import axios from "axios";

axios.interceptors.response.use(
    (res) => res,
    (err) => {
        throw new ApiErrorException({
            status: err?.response?.status,
            statusText: err?.response?.statusText,
            data: err?.response?.data,
            response: err?.toJSON(),
        });
    }
);

export class Settings {
    private static _BaseURL: string;
    private static _Authorization: any;

    public static set BaseURL(baseURL: string) {
        this._BaseURL = baseURL;
        axios.defaults.baseURL = baseURL;
    }

    public static get BaseURL(): string {
        return this._BaseURL;
    }

    public static set Authorization(Authorization: any) {
        this._Authorization = Authorization;
        axios.defaults.headers.common["Authorization"] = `Bearer ${Authorization.token}`;
    }

    public static get Authorization(): any {
        return this._Authorization;
    }
}
